export { default, styleFunction } from './Box';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/Box/index.js
// module id = 308
// module chunks = 0